<script setup lang="ts">
import BigNumber from "bignumber.js";

const props = defineProps<{ title: string, extraClass: string, frontAmount: BigNumber, frontToken: string, backAmount: BigNumber, backToken: string }>();
</script>

<template>
  <div :class="['container-block','container-price-block',props.extraClass]">
    <div class="alice-price-block-title">
      <span v-if="props.title">{{ props.title }}</span>
    </div>
    <div class="alice-price-block-value">
      <span id="swap-block-unit-value" v-if="props.frontAmount">{{ props.frontAmount }}&nbsp;</span>
      <span id="alice-price-block-value-front" v-if="props.frontToken">{{ props.frontToken }}</span>
      =
      <span id="swap-block-unit-price-feed" v-if="props.backAmount">{{
          props.backAmount.toFixed(5, BigNumber.ROUND_FLOOR)
        }}&nbsp;</span>
      <span id="alice-price-block-value-back" v-if="props.backToken">{{ props.backToken }}</span>
    </div>
  </div>
</template>

<style scoped>
.container-price-block {
  display: flex;
  flex-basis: max-content;
  height: 44px;
  width: 100%;
  margin: 0 6px 0 0;
  padding: 11px 13px 9px 12px;
  background-color: #fbfbfc;
}

.alice-price-block-title {
  display: inline;
  font-family: WorkSans;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.25px;
  text-align: left;
  color: var(--price-title-colour);
}

.alice-price-block-value {
  display: inline;
  flex-grow: 1;
  padding-top: 4px;
  font-family: WorkSans;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: var(--price-value-colour);
  padding-right: 4px;
}
</style>
